export const defaultLocale = "en"
export const prefersLangToken = "__farmers-prefers-lang"
